import { ContentComponent } from './../../../components/content/content.component';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * We are moving away from useMobileLayout instead we will show and hide using css
 */
@Component({
    selector: 'lib-cu-ng-design-library',
    imports: [RouterOutlet],
    template: `
    <div class="wrapper">
      <ng-content select="[header]"></ng-content>
      <ng-content select="[main-menu]"></ng-content>
      <div class="main-wrapper">
        <ng-content select="[alert]"></ng-content>
        <ng-content></ng-content>
        <router-outlet></router-outlet>
      </div>
      @defer {
      <ng-content select="[secondary]"></ng-content>
      } @defer {
      <ng-content select="[footer]"></ng-content>
      }
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: [
        `
      .wrapper {
        min-height: 100vh;
        margin: 0;
        display: flex;
        flex-direction: column;
      }

      .main-wrapper {
        flex: 1;
      }

      @media screen and (max-width: 768px) {
        .mobile-hidden {
          display: none;
        }
      }
    `,
    ]
})
export class CuNgDesignLibraryComponent {}
